export const GET_ITEMS = 'GET_ITEMS';
export const GET_GROUPINGS = 'GET_GROUPINGS';
export const CLEAR = 'CLEAR';
export const GET_FILTERED_ITEMS = 'GET_FILTERED_ITEMS';
export const API_HOST = 'https://webtools.au.dk';
